<!-- 入力内容確認画面 -->
<template>
  <div class="input-filed-container">
    <p class="confirm-thankYou">{{ $t("confirmation.thankYou") }}</p>
    <p class="confirm-information">
      {{ $t("confirmation.pleaseTapTheButtonDiagnose") }}
    </p>

    <heading :title="$t('yourInformation.yourInformation')" class="heading" />
    <DisplayConfirmation
      v-for="(userInfo, index) in userInfo"
      :key="`first-${index}`"
      :index="index"
      :label="$t(`yourInformation.${userInfo.label}`)"
      :value="userInfo.value"
      :unit="userInfo.unit"
      :gender="userInfo.gender"
      :dataTest="userInfo.label"
    />

    <heading
      :title="$t('yourPhysicalInformation.yourPhysicalInformation')"
      class="heading"
    />
    <div class="result-container">
      <DisplayConfirmation
        v-for="(physicalInfo, index) in physicalInfo"
        :key="`second-${index}`"
        :index="index"
        :label="$t(`yourPhysicalInformation.${physicalInfo.label}`)"
        :value="physicalInfo.value"
        :unit="physicalInfo.unit"
        :condition="physicalInfo.condition"
        :whetherAbnormalTest="physicalInfo.whetherAbnormalTest"
        :dataTest="physicalInfo.label"
      />
    </div>

    <heading
      :title="$t('yourPhysicalInformation.yourMedicalHistory')"
      class="heading"
    />
    <display-confirmation
      v-for="(medicalHistory, index) in medicalHistory"
      :key="`third-${index}`"
      :index="index"
      :label="$t(`diseases.${medicalHistory.label}`)"
      :value="medicalHistory.value"
      :diseaseHistory="medicalHistory.diseaseHistory"
      :dataTest="`your-${medicalHistory.label}`"
    />

    <heading
      :title="$t('yourFamilysMedicalHistory.yourFamilysMedicalHistory')"
      class="heading"
    />
    <display-confirmation
      v-for="(familyMedicalHistory, index) in familysMedicalHistory"
      :key="`forth-${index}`"
      :index="index"
      :label="$t(`diseases.${familyMedicalHistory.label}`)"
      :value="familyMedicalHistory.value"
      :diseaseHistory="familyMedicalHistory.diseaseHistory"
      :dataTest="`family-${familyMedicalHistory.label}`"
    />

    <heading :title="$t('bloodTestResult.yourBloodTest')" class="heading" />
    <display-confirmation
      v-for="(bloodTestResult, index) in bloodTestResult"
      :key="`fifth-${index}`"
      :index="index"
      :label="$t(`bloodTestResult.${bloodTestResult.label}`)"
      :value="bloodTestResult.value"
      :unit="bloodTestResult.unit"
      :dataTest="bloodTestResult.label"
    />

    <heading
      :title="$t('bloodTestResult.yoururinaryTestResult')"
      class="heading"
    />
    <display-confirmation
      v-for="(urinaryTestResult, index) in urinaryTestResult"
      :key="`seventh-${index}`"
      :index="index"
      :label="$t(`bloodTestResult.${urinaryTestResult.label}`)"
      :value="urinaryTestResult.value"
      :urinaryTest="urinaryTestResult.urinaryTest"
      :urinarySugar="urinaryTestResult.urinarySugar"
      :unit="urinaryTestResult.unit"
      :dataTest="urinaryTestResult.label"
    />

    <heading :title="$t('yourLifestyle.yourLifestyle')" class="heading" />
    <display-confirmation
      v-for="(yourLifestyle, index) in yourLifestyle"
      :key="`sixth-${index}`"
      :index="index"
      :label="$t(`yourLifestyle.${yourLifestyle.label}`)"
      :value="yourLifestyle.value"
      :unit="yourLifestyle.unit"
      :smokingHabit="yourLifestyle.smokingHabit"
      :dataTest="yourLifestyle.label"
    />

    <next-button
      :label="$t('confirmation.seeResult')"
      :disabled="false"
      @click="onSubmit"
      class="next-button"
    />
  </div>
</template>

<script>
import Heading from "../../components/atoms/Heading";
import DisplayConfirmation from "../../components/molecules/AiDiseasePrediction/DisplayConfirmation";
import NextButton from "../../components/atoms/NextButton";

export default {
  components: {
    Heading,
    DisplayConfirmation,
    NextButton,
  },
  computed: {
    smokingHabit(value) {
      switch (this.value) {
        case 1:
          return this.$i18n.t("yourLifestyle.neverSmoked");
        case 2:
          return this.$i18n.t("yourLifestyle.stopSmoking");
        case 3:
          return this.$i18n.t("yourLifestyle.smoking");
      }
    },
    userInfo() {
      return [
        {
          label: "name",
          value: this.$store.state.aiPrediction.karteData.name,
        },
        {
          label: "gender",
          value: this.$store.getters["aiPrediction/getSEX"],
          gender: true,
        },
        {
          label: "age",
          value: this.$store.getters["aiPrediction/getAGE"],
          unit: this.$i18n.t("yourLifestyle.yearsOld"),
        },
      ];
    },
    physicalInfo() {
      return [
        {
          label: "healthExamDate",
          value: this.$store.getters["aiPrediction/getT"],
        },
        {
          label: "condition",
          value: this.$store.getters["aiPrediction/getDFAB_PTN_CD"],
          condition: true,
        },
        {
          label: "waistCircumference",
          value: this.$store.getters["aiPrediction/getWAIST"],
          unit: "cm",
        },
        {
          label: "BMI",
          value: this.$store.getters["aiPrediction/getBMI"],
        },
        {
          label: "sbp",
          value: this.$store.getters["aiPrediction/getBP_HIGH"],
        },
        {
          label: "dbp",
          value: this.$store.getters["aiPrediction/getBP_LWST"],
        },
        // 新規追加項目
        {
          label: "Weight",
          value: this.$store.getters["aiPrediction/getWEIGHT"],
          unit: "kg",
        },
        {
          label: "Electrocardiography",
          value: this.$store.getters["aiPrediction/getELECTROCARDIOGRAPHY"],
          whetherAbnormalTest: true,
        },
        {
          label: "SputumExamination",
          value: this.$store.getters["aiPrediction/getSPUTUM_EXAMINATION"],
          whetherAbnormalTest: true,
        },
        // 聴力 1000Hz
        {
          label: "HearingLabel1000HzLeft",
          value: this.$store.getters["aiPrediction/getHEARING_LOW_LEFT"],
          whetherAbnormalTest: true,
        },
        {
          label: "HearingLabel1000HzRight",
          value: this.$store.getters["aiPrediction/getHEARING_LOW_RIGHT"],
          whetherAbnormalTest: true,
        },
        // 聴力 4000Hz
        {
          label: "HearingLabel4000HzLeft",
          value: this.$store.getters["aiPrediction/getHEARING_HIGH_LEFT"],
          whetherAbnormalTest: true,
        },
        {
          label: "HearingLabel4000HzRight",
          value: this.$store.getters["aiPrediction/getHEARING_HIGH_RIGHT"],
          whetherAbnormalTest: true,
        },
        // 視力 裸眼
        {
          label: "UncorrectedEyeSightLeft",
          value: this.$store.getters["aiPrediction/getWITHOUT_GLASSES_LEFT"],
        },
        {
          label: "UncorrectedEyeSightRight",
          value: this.$store.getters["aiPrediction/getWITHOUT_GLASSES_RIGHT"],
        },
        // 視力　矯正
        {
          label: "CorrectedEyeSightLeft",
          value: this.$store.getters["aiPrediction/getWITH_GLASSES_LEFT"],
        },
        {
          label: "CorrectedEyeSightRight",
          value: this.$store.getters["aiPrediction/getWITH_GLASSES_RIGHT"],
        },
      ];
    },
    medicalHistory() {
      return [
        {
          label: "stroke",
          value: this.$store.getters["aiPrediction/getHCHK_APOP_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "diabetes",
          value: this.$store.getters["aiPrediction/getHCHK_DIABML_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "cancerOrOther",
          value: this.$store.getters["aiPrediction/getHCHK_ETCDSE_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "heartDisease",
          value: this.$store.getters["aiPrediction/getHCHK_HDISE_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "highBloodPressure",
          value: this.$store.getters["aiPrediction/getHCHK_HPLPDM_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "hyperlipemia",
          value: this.$store.getters["aiPrediction/getHCHK_HPRTS_PMH_YN"],
          diseaseHistory: true,
        },
        {
          label: "tuberculosis",
          value: this.$store.getters["aiPrediction/getHCHK_PHSS_PMH_YN"],
          diseaseHistory: true,
        },
      ];
    },
    familysMedicalHistory() {
      return [
        {
          label: "stroke",
          value: this.$store.getters["aiPrediction/getFMLY_APOP_PATIEN_YN"],
          diseaseHistory: true,
        },
        {
          label: "diabetes",
          value: this.$store.getters["aiPrediction/getFMLY_DIABML_PATIEN_YN"],
          diseaseHistory: true,
        },
        {
          label: "cancerOrOther",
          value: this.$store.getters["aiPrediction/getFMLY_CANCER_PATIEN_YN"],
          diseaseHistory: true,
        },
        {
          label: "heartDisease",
          value: this.$store.getters["aiPrediction/getFMLY_HDISE_PATIEN_YN"],
          diseaseHistory: true,
        },
        {
          label: "highBloodPressure",
          value: this.$store.getters["aiPrediction/getFMLY_HPRTS_PATIEN_YN"],
          diseaseHistory: true,
        },
      ];
    },
    bloodTestResult() {
      return [
        {
          label: "fastingBloodSugarLevel",
          value: this.$store.getters["aiPrediction/getBLDS"],
          unit: "mg/dL",
        },
        // HbA1c
        {
          label: "HbA1c",
          value: this.$store.getters["aiPrediction/getHBA1C"],
          unit: "%",
        },
        {
          label: "totalCholesterol",
          value: this.$store.getters["aiPrediction/getTOT_CHOLE"],
          unit: "mg/dL",
        },
        {
          label: "triglyceride",
          value: this.$store.getters["aiPrediction/getTRIGLYCERIDE"],
          unit: "mg/dL",
        },
        {
          label: "hdlcholesterol",
          value: this.$store.getters["aiPrediction/getHDL_CHOLE"],
          unit: "mg/dL",
        },
        {
          label: "ldlCholesterol",
          value: this.$store.getters["aiPrediction/getLDL_CHOLE"],
          unit: "mg/dL",
        },
        {
          label: "hemoglobin",
          value: this.$store.getters["aiPrediction/getHMG"],
          unit: "g/dL",
        },
        // 新規項目追加
        {
          label: "whiteBloodCells",
          value: this.$store.getters["aiPrediction/getWHITE_BLC"],
          unit: "/μL",
        },
        {
          label: "redBloodCells",
          value: this.$store.getters["aiPrediction/getRED_BLC"],
          unit: "10^4/μL",
        },
        {
          label: "plateletCount",
          value: this.$store.getters["aiPrediction/getPLT_CNT"],
          unit: "10^4/μL",
        },
        {
          label: "hematocrit",
          value: this.$store.getters["aiPrediction/getHEMATOCRIT"],
          unit: "％",
        },
        //
        {
          label: "γGtp",
          value: this.$store.getters["aiPrediction/getGAMMA_GTP"],
          unit: "U/L",
        },
        {
          label: "AST",
          value: this.$store.getters["aiPrediction/getSGOT_AST"],
          unit: "U/L",
        },
        {
          label: "ALT",
          value: this.$store.getters["aiPrediction/getSGPT_ALT"],
          unit: "U/L",
        },
      ];
    },
    urinaryTestResult() {
      return [
        {
          label: "urinaryProtein",
          value: this.$store.getters["aiPrediction/getOLIG_PROTE_CD"],
          urinaryTest: true,
        },
        {
          label: "serumCreatinine",
          value: this.$store.getters["aiPrediction/getCREATININE"],
          unit: "mg/DL",
        },
        // 尿酸
        {
          label: "urinaryAcid",
          value: this.$store.getters["aiPrediction/getURIC_ACID"],
          unit: "mg/dL",
        },
        // 尿糖
        {
          label: "urinarySugar",
          value: this.$store.getters["aiPrediction/getURIC_SUGAR"],
          urinarySugar: true,
        },
      ];
    },
    yourLifestyle() {
      return [
        // 喫煙
        {
          label: "smokingHabit",
          value: this.$store.getters["aiPrediction/getSMK_STAT_TYPE_RSPS_CD"],
          smokingHabit: true,
        },
        // 禁煙以前の1日の平均喫煙量
        {
          label: "averageSmokingAmountInADayBefore",
          value: this.$store.getters["aiPrediction/getPAST_DSQTY_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.ea/day"),
        },
        // 禁煙以前の喫煙期間
        {
          label: "smokingPeriodBeforeStopSmoking",
          value: this.$store.getters["aiPrediction/getPAST_SMK_TERM_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.year(s)"),
        },
        // 1日の平均喫煙量
        {
          label: "averageSmokingAmountInADay",
          value: this.$store.getters["aiPrediction/getCUR_DSQTY_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.ea/day"),
        },
        // 喫煙期間
        {
          label: "smokingPeriod",
          value: this.$store.getters["aiPrediction/getCUR_SMK_TERM_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.year(s)"),
        },
        // 1週間の平均飲酒日数
        {
          label: "averageNumberOfDrinkingDaysInAWeek",
          value: this.$store.getters["aiPrediction/getDRNK_HABIT_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        // 1日の飲酒量
        {
          label: "drinkingAmountInADay",
          value: this.$store.getters["aiPrediction/getTM1_DRKQTY_RSPS_CD"],
          unit: this.$i18n.t("yourLifestyle.cup(s)"),
        },
        // 1週間の平均飲酒量
        {
          label: "averageNumberOfAmountInAWeek",
          value: this.$store.getters["aiPrediction/getDRNK_QTY_WEK_CD"],
          unit: this.$i18n.t("yourLifestyle.cup(s)"),
        },
        {
          label: "numberOfHigh-intensityExerciseDays",
          value: this.$store.getters["aiPrediction/getMOV20_WEK_FREQ_ID"],
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        {
          label: "numberOfMid-intensityExerciseDays",
          value: this.$store.getters["aiPrediction/getMOV30_WEK_FREQ_ID"],
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
        {
          label: "numberOfLightExerciseDays",
          value: this.$store.getters["aiPrediction/getWLK30_WEK_FREQ_ID"],
          unit: this.$i18n.t("yourLifestyle.day(s)"),
        },
      ];
    },
  },
  methods: {
    setKarteData() {
      const currentDate = this.$store.getters["aiPrediction/getT"].replace(
        /-/g,
        ""
      );
      this.$store.dispatch("karte/setKarte", {
        uid: this.$store.state.auth.user.uid,
        date: currentDate,
        karteData: this.$store.state.aiPrediction.karteData,
      });
    },
    onSubmit() {
      this.setKarteData();
      this.$router.push({ name: "selectPayment" });
    },
  },
  created() {
    //スクロールの位置を初期化；　indexをページトップにする処理
    scrollTo(0, 0);
  },
};
</script>

<style scoped>
.input-filed-container {
  width: 100%;
  margin: auto;
}
.confirm-thankYou {
  font-weight: bold;
  font-size: 20px;
}
.confirm-information {
  font-size: 18px;
  text-align: left;
  padding-left: 20px;
  margin-top: 20px;
}
.heading {
  margin-top: 20px;
}

.next-button {
  margin-top: 40px;
}
</style>
